import { alpha, Stack, Typography, useTheme } from "@mui/material";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { LabeledValueRow } from "web_myplann/Shared/Components/LabeledValueRow";

type Props = {
	monthlyRent: number;
	statePension: number;
	privateMonthly: number;
	currencySuffix: string;
};

export const PensionBreakdownRow: React.FC<Props> = ({
	monthlyRent,
	statePension,
	privateMonthly,
	currencySuffix,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<Stack
			px={1.6}
			py={1.5}
			gap={0.4}
			borderTop={`1px solid ${theme.palette.grey[100]}`}
			bgcolor={alpha(theme.palette.primary.main, 0.04)}
		>
			<LabeledValueRow
				label={
					<Typography variant="caption" color={theme.palette.grey[600]}>
						{t(Resources.Goals.Form.Pension.privateMonthlyLabel)}
					</Typography>
				}
				value={
					<Typography
						variant="bodyStrong"
						color={theme.palette.primary.main}
						tabular
					>
						{privateMonthly.toLocaleString("cs-CZ")} {currencySuffix}
					</Typography>
				}
			/>
			<Typography variant="caption" color={theme.palette.grey[500]} tabular>
				{t(Resources.Goals.Form.Pension.privateMonthlyBreakdown, {
					desired: `${monthlyRent.toLocaleString("cs-CZ")} ${currencySuffix}`,
					state: `${statePension.toLocaleString("cs-CZ")} ${currencySuffix}`,
				})}
			</Typography>
		</Stack>
	);
};
